import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useMessageClassification } from "./ExpertMessageClassificationHook";
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
// Set the default state values for each context
export const ExpertMessageClassficationContext = /*#__PURE__*/createContext({});
export const ExpertMessageClassficationContextProvider = ({
  children
}) => {
  const messageClassification = useMessageClassification();
  const {
    stateTracker
  } = useDevLogging();
  stateTracker.trackState({
    messageClassification: messageClassification.messageClassification
  });
  return /*#__PURE__*/React.createElement(ExpertMessageClassficationContext.Provider, {
    value: messageClassification
  }, children);
};
export const useExpertMessageClassficationContext = () => {
  return useContext(ExpertMessageClassficationContext);
};
ExpertMessageClassficationContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};